import { get, getServiceResponse, handleClientError } from '../lib'
import { getToken } from '../APIServices'

export interface ServerInfoResponse {
  version: string
  cpuinfo: {
    modelName: string
    processors: number
  }
  meminfo: {
    memTotal: number
    memFree: number
    memAvail: number
  }
  network: {
    name: string
    mac: string
  }[]
  extensions: ServerExtension[]
}

export type ServerExtension = {
  id: number
  val: string
  what: string
  category: string
  version: number
  enabled: boolean
}

export type deviceFleetResponse = {
  name: string
  vehicle: string
  type: string
  isLicensed: boolean
  expiration: string
  components: {
    'Client Build'?: string
    Kernel?: string
    OS?: string
    firmctrl?: string
    SCHIP?: string
    Bootloader?: string
    'VSpy X Library'?: string
    Hardware?: string
    ZCHIP?: string
    CoreMini?: string
    Client?: string
  }
}

export interface ServerDownloadResponse {
  server_component: Record<string, string>
  device_fleets: Record<string, Record<string, deviceFleetResponse>>
}

export const getServerInfo = async (): Promise<ServerInfoResponse> => {
  const token = getToken()
  try {
    const res: ServerInfoResponse = await get<ServerInfoResponse>({
      path: '/api/v1/serverLogs/serverInfo',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    })
    return {
      ...res,
      extensions: await getServerExtensions()
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    throw handleClientError(e)
  }
}

export const getServerExtensions = async (): Promise<ServerExtension[]> => {
  //TODO: FIX ANY
  const token = getToken()
  const server_extension_url =
    'serverSettings?filter%5B0%5D%5Bfield%5D=category&filter%5B0%5D%5Boperator%5D=eq&filter%5B0%5D%5Bvalue%5D=extension'
  return get<ServerExtension[]>({
    path: `/api/v1/${server_extension_url}`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    }
  })
}

export const getServerDownload = async (): Promise<ServerDownloadResponse> => {
  const token = getToken()
  return get<ServerDownloadResponse>({
    path: '/api/v1/serverInformation/overview',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token
    }
  })
}
